<ng-template [ngIf]="hasMarketoFlowId(gated, marketoFlowId)" [ngIfElse]="elseContent">
	<button *ngIf="!buttonlink; else link" [ngClass]="getClass()" [innerHTML]="text" data-t-name="Button"
	  [attr.data-t-decorator]="decorator" [disabled]="disabled"
	  [attr.data-mktoflow-id]="getMarketoFlowId(gated, marketoFlowId)"
	  [attr.data-mktocampaign-id]="getCampaignId(campaignId)"
	  [attr.data-mktoflow-close-disabled]="IsCloseButtonDisabled(closebuttondisabled)"
	  (click)="btnDownloadClicked($event)"></button>
	<ng-template #link>
	  <a [ngClass]="getClass()" [href]="href" [target]="target" [rel]="rel" [innerHTML]="text" data-t-name="Button"
		[attr.data-t-decorator]="decorator" [attr.data-mktoflow-id]="getMarketoFlowId(gated, marketoFlowId)"
		[attr.data-mktocampaign-id]="getCampaignId(campaignId)"
		[attr.data-mktoflow-close-disabled]="IsCloseButtonDisabled(closebuttondisabled)"
		(click)="btnDownloadClicked($event)"></a>
	</ng-template>
  </ng-template>

  <ng-template #elseContent>
	<ng-container *ngIf="hasCdcFlowId(gated, formFlowId); else elseContent1">
	  <button *ngIf="!buttonlink; else linkCdc" [ngClass]="getClass()" [innerHTML]="text" data-t-name="Button"
		[attr.data-t-decorator]="decorator" [disabled]="disabled"
		[attr.data-formflow-id]="getCdcFlowId(gated, formFlowId)"
		[attr.data-formcampaign-id]="getCampaignId(campaignId)"
		[attr.data-formflow-close-disabled]="IsCloseButtonDisabled(closebuttondisabled)"
		(click)="btnCdcDownloadClicked($event)"></button>
	  <ng-template #linkCdc>
		<a [ngClass]="getClass()" [href]="href" [target]="target" [rel]="rel" [innerHTML]="text" data-t-name="Button"
		  [attr.data-t-decorator]="decorator" [attr.data-formflow-id]="getCdcFlowId(gated, formFlowId)"
		  [attr.data-formcampaign-id]="getCampaignId(campaignId)"
		  [attr.data-formflow-close-disabled]="IsCloseButtonDisabled(closebuttondisabled)"
		  (click)="btnCdcDownloadClicked($event)"></a>
	  </ng-template>
	</ng-container>
  </ng-template>

  <ng-template #elseContent1>
	<button *ngIf="!buttonlink; else linkFallback" [ngClass]="getClass()" [innerHTML]="text" data-t-name="Button"
	  [attr.data-t-decorator]="decorator" [disabled]="disabled" (click)="onClick($event)"></button>
	<ng-template #linkFallback>
	  <a [ngClass]="getClass()" [href]="href" [target]="target" [rel]="rel" [innerHTML]="text" data-t-name="Button"
		[attr.data-t-decorator]="decorator" (click)="onClick($event)"></a>
	</ng-template>
  </ng-template>
